module.exports = __webpack_public_path__ + "static/media/productCategory-10.57d47677.png";